import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class JwtDecodeService {
  decodeJWTToken(token: string): any {
    try {
      return jwtDecode(token);
    } catch {
      return null;
    }
  }
}

